module.exports = __webpack_public_path__ + "img/6.616cb47a.png";